import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { TypeHeritageViewControllerDelegate, TypeHeritageViewController } from "../../Screen/TypeHeritage/TypeHeritageViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { TypeHeritageViewModel } from '../../Screen/TypeHeritage/TypeHeritageViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class TypeHeritageCoordinator implements IndexCoordinatorDelegate, TypeHeritageViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geptipopatrimonio")
        return (<ProtectedRoute requiredPermissions={['prop.tipo_patrim.*']} path="/:base/tipo-patrimonio" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'prop.tipo_patrim.adicionar',
                    edit: 'prop.tipo_patrim.editar',
                    delete: 'prop.tipo_patrim.excluir',
                }} 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Tipo de Patrimônio"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new TypeHeritageViewModel()
        return (<ProtectedRoute requiredPermissions={['prop.tipo_patrim.adicionar', 'prop.tipo_patrim.editar']} path="/:base/tipo-patrimonio/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<TypeHeritageViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geptipopatrimonio") {
            navigation.history.push(`tipo-patrimonio/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geptipopatrimonio") {
            navigation.history.push(`tipo-patrimonio/cad/${idSelection}`);
            return;
        }
    }

}